import React from 'react';
import { Badge } from '@amzn/awsui-components-react';

export function TsaLinkedBadge({ item }: { item: { learningGoalIds?: string[] } }) {
    if (!item.learningGoalIds?.length) return null;
    return <Badge color='green'>Organization Initiative</Badge>;
}
